import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import ProjEditImageDomUtil from "./ProjEditImageDomUtil";

export default class ProjEditImageAryDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChange = this.onChange.bind(this);
        this.onAdd = this.onAdd.bind(this);
    }

    onChange(i, url) {
        // onChange(i, event) {
        // console.log(event.target, i);
        // let tmp = this.props.value;
        // tmp[i] = event.target.value;
        // this.props.onChange(this.props.dataKey, tmp);
        let tmp = this.props.value;
        tmp[i] = url;
        console.log(this.props.dataKey, tmp);
        this.props.onChange(this.props.dataKey, tmp);
    }

    onAdd(event) {
        console.log(event.target);
        this.props.onChange(this.props.dataKey, this.props.value ? this.props.value.concat('') : [""]);
    }

    render() {
        const { isDisabled, data, value } = this.props;

        let tmp = [];
        if (null != value && value.length && value.length > 0) {
            for (const [index, val] of Object.entries(value)) {
                let tmpIndex = parseInt(index);
                tmpIndex = isNaN(tmpIndex) ? value : tmpIndex + 1;
                tmp.push(
                    <div key={index} className="ml-3">
                        <label>內頁圖{tmpIndex}</label>
                        <ProjEditImageDomUtil
                            isDisabled={isDisabled}
                            key={index}
                            dataKey={index}
                            value={val}
                            onChange={this.onChange}
                            id={this.props.pid}
                            type={0} //0 : 專案, 1 : 廣告, 2 : 商品
                        />
                    </div>
                );
            }

        } else if (isDisabled) {
            tmp.push(
                <div key="na">
                    <label>無</label>
                </div>
            )
        }

        if (isDisabled) {
            tmp.push(null);
        } else {
            tmp.push(
                <div key={-1} className="mt-2">
                    <button type="button" className="btn btn-primary" onClick={this.onAdd}>新增</button>
                </div>
            );
        }

        return (
            <Col className="mb-2 projEditImage">
                <label>{data.name}</label>
                <div>
                    {tmp}
                </div>
            </Col>
        );
    }
}